// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quick-upload-container,
.upload-progress-container {
  padding: 0;
}

.quick-upload-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 8px 8px 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.quick-upload-title {
  font-weight: 500;
  font-size: 14px;
}

.quick-upload-content {
  padding: 16px;
}

.quick-upload-info {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  padding: 12px;
  background: rgba(0, 0, 0, 0.04);
  border-radius: 8px;
}

.file-icon {
  color: rgba(0, 0, 0, 0.54);
}

.file-name {
  font-weight: 500;
  flex-shrink: 0;
}

.arrow-icon {
  color: rgba(0, 0, 0, 0.38);
  font-size: 18px;
  width: 18px;
  height: 18px;
}

.destination {
  color: rgba(0, 0, 0, 0.7);
  font-family: monospace;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.quick-upload-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.progress-list {
  padding: 16px;
}

.progress-item {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.progress-msg {
  font-size: 13px;
}

.folder-picker-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.folder-picker-content {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 16px;
  min-height: 0;
}

.file-summary {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: rgba(0, 0, 0, 0.04);
  border-radius: 4px;
  margin-bottom: 12px;
  font-size: 13px;
}
.file-summary mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: rgba(0, 0, 0, 0.54);
}

.directory-wrapper {
  flex: 1;
  overflow: auto;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  margin-bottom: 12px;
}
.directory-wrapper app-directory {
  display: block;
  max-height: 200px;
}

.folder-picker-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.file-input {
  display: none;
}

.btn {
  padding-top: 15px;
}

.drop-icon-container {
  margin-top: 300px;
}
.drop-icon-container > * {
  transform: scale(5);
}

.drop-icon-hint {
  margin-top: 100px;
}
.drop-icon-hint span {
  font-weight: bold;
}

.progress-container {
  margin-bottom: 10px;
}

.progress {
  padding-left: 5px;
}

.complete {
  color: green;
}

.error {
  color: red;
}

.icon {
  padding: 12px 6px 6px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/file-upload-dialog/file-upload-dialog.component.scss"],"names":[],"mappings":"AACA;;EAEE,UAAA;AAAF;;AAGA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,yBAAA;EACA,4CAAA;AAAF;;AAGA;EACE,gBAAA;EACA,eAAA;AAAF;;AAGA;EACE,aAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,aAAA;EACA,+BAAA;EACA,kBAAA;AAAF;;AAGA;EACE,0BAAA;AAAF;;AAGA;EACE,gBAAA;EACA,cAAA;AAAF;;AAGA;EACE,0BAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AAAF;;AAGA;EACE,yBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,aAAA;EACA,yBAAA;EACA,QAAA;AAAF;;AAGA;EACE,aAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AAAF;;AAGA;EACE,eAAA;AAAF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,OAAA;EACA,aAAA;EACA,aAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,+BAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AADF;AAGE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,0BAAA;AADJ;;AAKA;EACE,OAAA;EACA,cAAA;EACA,qCAAA;EACA,kBAAA;EACA,mBAAA;AAFF;AAIE;EACE,cAAA;EACA,iBAAA;AAFJ;;AAMA;EACE,aAAA;EACA,yBAAA;EACA,QAAA;AAHF;;AAMA;EACE,aAAA;AAHF;;AAMA;EACE,iBAAA;AAHF;;AAMA;EACE,iBAAA;AAHF;AAKE;EACE,mBAAA;AAHJ;;AAOA;EACE,iBAAA;AAJF;AAME;EACE,iBAAA;AAJJ;;AAQA;EACE,mBAAA;AALF;;AAQA;EACE,iBAAA;AALF;;AAQA;EACE,YAAA;AALF;;AAQA;EACE,UAAA;AALF;;AAQA;EACE,qBAAA;AALF","sourcesContent":["// Quick Upload Mode styles\n.quick-upload-container,\n.upload-progress-container {\n  padding: 0;\n}\n\n.quick-upload-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 8px 8px 16px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n}\n\n.quick-upload-title {\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.quick-upload-content {\n  padding: 16px;\n}\n\n.quick-upload-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 16px;\n  padding: 12px;\n  background: rgba(0, 0, 0, 0.04);\n  border-radius: 8px;\n}\n\n.file-icon {\n  color: rgba(0, 0, 0, 0.54);\n}\n\n.file-name {\n  font-weight: 500;\n  flex-shrink: 0;\n}\n\n.arrow-icon {\n  color: rgba(0, 0, 0, 0.38);\n  font-size: 18px;\n  width: 18px;\n  height: 18px;\n}\n\n.destination {\n  color: rgba(0, 0, 0, 0.7);\n  font-family: monospace;\n  font-size: 12px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.quick-upload-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.progress-list {\n  padding: 16px;\n}\n\n.progress-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.progress-msg {\n  font-size: 13px;\n}\n\n// Folder Picker styles\n.folder-picker-container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.folder-picker-content {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  padding: 16px;\n  min-height: 0;\n}\n\n.file-summary {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  background: rgba(0, 0, 0, 0.04);\n  border-radius: 4px;\n  margin-bottom: 12px;\n  font-size: 13px;\n\n  mat-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n    color: rgba(0, 0, 0, 0.54);\n  }\n}\n\n.directory-wrapper {\n  flex: 1;\n  overflow: auto;\n  border: 1px solid rgba(0, 0, 0, 0.12);\n  border-radius: 4px;\n  margin-bottom: 12px;\n\n  app-directory {\n    display: block;\n    max-height: 200px;\n  }\n}\n\n.folder-picker-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.file-input {\n  display: none;\n}\n\n.btn {\n  padding-top: 15px;\n}\n\n.drop-icon-container {\n  margin-top: 300px;\n\n  & > * {\n    transform: scale(5);\n  }\n}\n\n.drop-icon-hint {\n  margin-top: 100px;\n\n  span {\n    font-weight: bold;\n  }\n}\n\n.progress-container {\n  margin-bottom: 10px;\n}\n\n.progress {\n  padding-left: 5px;\n}\n\n.complete {\n  color: green;\n}\n\n.error {\n  color: red;\n}\n\n.icon {\n  padding: 12px 6px 6px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
